import { render } from "./TheAppLayout.vue?vue&type=template&id=5e512781"
import script from "./TheAppLayout.vue?vue&type=script&lang=js"
export * from "./TheAppLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__